/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EnrollmentCreated } from './EnrollmentCreated';
import {
    EnrollmentCreatedFromJSON,
    EnrollmentCreatedFromJSONTyped,
    EnrollmentCreatedToJSON,
    EnrollmentCreatedToJSONTyped,
} from './EnrollmentCreated';
import type { EnrollmentFailed } from './EnrollmentFailed';
import {
    EnrollmentFailedFromJSON,
    EnrollmentFailedFromJSONTyped,
    EnrollmentFailedToJSON,
    EnrollmentFailedToJSONTyped,
} from './EnrollmentFailed';
import type { EnrollmentWarning } from './EnrollmentWarning';
import {
    EnrollmentWarningFromJSON,
    EnrollmentWarningFromJSONTyped,
    EnrollmentWarningToJSON,
    EnrollmentWarningToJSONTyped,
} from './EnrollmentWarning';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface CreateBulkEnrollmentResponse
 */
export interface CreateBulkEnrollmentResponse {
    /**
     * 
     * @type {Array<EnrollmentCreated>}
     * @memberof CreateBulkEnrollmentResponse
     */
    created?: Array<EnrollmentCreated>;
    /**
     * 
     * @type {Array<EnrollmentFailed>}
     * @memberof CreateBulkEnrollmentResponse
     */
    failed?: Array<EnrollmentFailed>;
    /**
     * 
     * @type {Array<EnrollmentWarning>}
     * @memberof CreateBulkEnrollmentResponse
     */
    warnings?: Array<EnrollmentWarning>;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof CreateBulkEnrollmentResponse
     */
    totalRequested?: ApiUserTasksGetPageParameter;
}

/**
 * Check if a given object implements the CreateBulkEnrollmentResponse interface.
 */
export function instanceOfCreateBulkEnrollmentResponse(value: object): value is CreateBulkEnrollmentResponse {
    return true;
}

export function CreateBulkEnrollmentResponseFromJSON(json: any): CreateBulkEnrollmentResponse {
    return CreateBulkEnrollmentResponseFromJSONTyped(json, false);
}

export function CreateBulkEnrollmentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateBulkEnrollmentResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'created': json['created'] == null ? undefined : ((json['created'] as Array<any>).map(EnrollmentCreatedFromJSON)),
        'failed': json['failed'] == null ? undefined : ((json['failed'] as Array<any>).map(EnrollmentFailedFromJSON)),
        'warnings': json['warnings'] == null ? undefined : ((json['warnings'] as Array<any>).map(EnrollmentWarningFromJSON)),
        'totalRequested': json['totalRequested'] == null ? undefined : ApiUserTasksGetPageParameterFromJSON(json['totalRequested']),
    };
}

export function CreateBulkEnrollmentResponseToJSON(json: any): CreateBulkEnrollmentResponse {
    return CreateBulkEnrollmentResponseToJSONTyped(json, false);
}

export function CreateBulkEnrollmentResponseToJSONTyped(value?: CreateBulkEnrollmentResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'created': value['created'] == null ? undefined : ((value['created'] as Array<any>).map(EnrollmentCreatedToJSON)),
        'failed': value['failed'] == null ? undefined : ((value['failed'] as Array<any>).map(EnrollmentFailedToJSON)),
        'warnings': value['warnings'] == null ? undefined : ((value['warnings'] as Array<any>).map(EnrollmentWarningToJSON)),
        'totalRequested': ApiUserTasksGetPageParameterToJSON(value['totalRequested']),
    };
}

